import React from 'react';
import { ChevronRight, LucideProps } from 'lucide-react';

/**
 * Standardized ChevronRight icon component.
 * Wraps the lucide-react ChevronRight icon for consistent usage across the app.
 */
export const ChevronRightIcon: React.FC<LucideProps> = (props) => {
  return <ChevronRight {...props} />;
};
